import styled, { css, keyframes } from 'styled-components';
import { IPropsStyles as ContainerProps } from '.';

export type IButtonRipple = {
  x: number;
  y: number;
};

const ripple = keyframes`
  0% {
    opacity: 0.3;
    transform: scale(1);
  }

  50% {
    transform: scale(8);
  }

  100% {
    opacity: 0;
  }
  `;

export const Container = styled.button<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  outline: transparent;

  cursor: pointer;
  border: 0;
  border-radius: 33px;
  transition: all 0.2s cubic-bezier(0.06, 0.67, 0.37, 0.99);
  text-transform: ${({ font }) => (font?.uppercase ? 'uppercase' : 'none')};
  background-color: ${({ theme, background }) =>
    background ? theme.colors[background] : theme.colors.transparent};
  color: ${({ theme, color }) => theme.colors[color!]} !important;
  color: ${({ theme, background, color }) => background && !color && theme.colors.background_white};
  color: ${({ theme, background, color }) => !background && color && theme.colors[color]};
  color: ${({ theme, background, color }) => !background && !color && theme.colors.primary};

  ${({ theme, background, border }) =>
    !background &&
    css`
      border: ${border?.width || 1}px solid ${theme.colors[border?.color!] || theme.colors.primary};
    `};

  ${({ theme, background }) =>
    background &&
    css`
      background-color: ${background === 'primary' || background === 'secondary'
        ? theme.colors[background]
        : background} !important;
    `};

  font-size: ${({ font }) => font?.size || 21}px;
  font-weight: ${({ font }) => font?.weight || 300};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}

  &:hover {
    transition: all linear 300ms;
  }

  ${({ disabled, background }) =>
    !disabled &&
    background &&
    background !== 'primary' &&
    background !== 'secondary' &&
    css`
      &:hover {
        filter: brightness(90%);
      }
    `}

  ${({ disabled, textHoverColor, theme, backgroundHoverColor, background }) =>
    !disabled &&
    css`
      &:hover {
        color: ${theme.colors[textHoverColor!] || theme.colors.gray_200}!important;
        background-color: ${theme.colors[backgroundHoverColor!] ||
        (background === 'primary'
          ? theme.colors.secondary
          : background === 'secondary' || !background
          ? theme.colors.primary
          : background)} !important;
      }
    `}

   .containerItens {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 0.2rem;

    .containerIcon {
      display: flex;
      align-items: center;
    }

    .text {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const ButtonRipple = styled.div<IButtonRipple>`
  position: absolute;
  top: ${(props) => props.y}px;
  left: ${(props) => props.x}px;
  height: ${50}px;
  width: ${50}px;
  background: currentColor;
  border-radius: 50%;
  opacity: 0.3;
  animation-name: ${ripple};
  animation-duration: ${800 * 2}ms;
  animation-iteration-count: 1;
  animation-timing-function: ease;
  pointer-events: none;
`;
